export default __webpack_public_path__ + "e4b50833eb026aa2d851d8534111bfcd.gif";